import { avatar } from "utils/assets_exports/images";
import UserPopover from "./UserPopover";
import { DemoUserObject } from "assets/data/usersData";
import { Link } from "react-router-dom";

export type PostUserBlockProps = {
    user: DemoUserObject;
    time: string;
};

const PostUserBlock = ({ user, time }: PostUserBlockProps) => {
    return (
        <div className="user-block flex gap-1">
            <div className="image relative">
                <img src={user.url || avatar} data-user-popover="1" alt="" />
                <UserPopover user={user} />
            </div>
            <div className="user-info flex flex-col ">
                <Link to="#" className="relative z-2">
                    {user.name}
                </Link>
                <span className="time">{time}</span>
            </div>
        </div>
    );
};

export default PostUserBlock;
